// extracted by mini-css-extract-plugin
export var menuItem = "F_vr d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "F_vs d_Z d_bz d_bP";
export var menuMainLink = "F_vt d_f0 d_dB";
export var menuLink = "F_vv d_f0 d_dB";
export var icon = "F_q1 d_bC d_bP";
export var divider = "F_vw d_bC d_bP";
export var sublinks = "F_vx";
export var link = "F_mZ";
export var Link = "F_tg C_tg C_sJ C_s2";